import * as React from 'react';
import { Card, Row, Col, Input, Breadcrumb, message, Tag } from 'antd';
import { IcommonProps } from '../common/props';
import ShareList from './ShareList';
import '../../css/ViewUser.scss';
// import Print from '../common/print';
// import Export from '../common/export';
import { STATICKEYS, staticProperties } from '../common/staticProperties';
import { MSGDISPLAYTIME } from '../common/constants';
import service from '../../service/apolloclient.service';
import { VIEWSTATE } from '../common/constants';
import Auth from '../common/auth';
import { Tasks } from '../common/auth';
// import { BASELINETYPE } from '../common/constants';
import Utils from '../common/utils';
// import UserIcon from '../../images/illustrationprofile.svg';
import strings from '../../eyeguide-localization/user/strings.user.view';
import strings_dashboard from '../../eyeguide-localization/strings.dashboard';
import Token from '../common/token';

const userIcon = require('../../images/illustration-profile.png');

/**
 * Property definition 
 */
interface IViewUserProps extends IcommonProps {
    match: any;
    loctaion: any;
}
/**
 * State definition
 */
interface IViewUserState {
    sportsArr: string;
    levelVal: any;
    gender: any;
    shares: any;
    exportModalVisisble: boolean;
    shareModalVisible: boolean;
    shareUsers: any;
    user: any;
    firstname: string;
    lastname: string;
    loading: boolean;
    emptyText: string;
    canEditOrganization: boolean;
    showEditAction: boolean;
    showHealthData: boolean;
    externalUsers: any;
    shareTests: any;
    rtaColumnData: any;
    rtaColumns: any;
    testListLoading: boolean;
    testListText: string;
}

export default class ViewUser extends React.Component<IViewUserProps, IViewUserState> {
    firstname:      React.RefObject<Input> ;
    lastname:       React.RefObject<Input> ;
    birthdate:      React.RefObject<any> ;
    id:             React.RefObject<Input> ;
    gender:         React.RefObject<Input> ;
    level:          React.RefObject<Input> ;
    sport:          any ;
    email:          React.RefObject<Input> ;
    phone:          React.RefObject<Input> ;
    notifyEmail:    React.RefObject<Input> ;
    notifyPhone:    React.RefObject<Input> ;
    organization:   React.RefObject<Input> ;
    metaInfoMap: any;
    iframe: HTMLIFrameElement | null;

    constructor(props: IViewUserProps) {
        super(props); 
        let roleid: number = parseInt(Token.decodeToken().roleid, 10);
        this.firstname = React.createRef();
        this.lastname = React.createRef();
        this.birthdate = React.createRef();
        this.id = React.createRef();
        this.sport = '';
        this.level = React.createRef();
        this.organization = React.createRef();
        this.email = React.createRef();
        this.phone  = React.createRef();
        this.notifyEmail = React.createRef();
        this.notifyPhone = React.createRef();
        this.gender = React.createRef();
        this.state = {
            sportsArr: '',
            levelVal: '',
            gender: '',
            shares: [],
            exportModalVisisble: false,
            shareModalVisible: false,
            shareUsers: [],
            user: [],
            firstname: '',
            lastname: '',
            loading: true,
            emptyText: '',
            canEditOrganization: true,
            showEditAction: Auth.canPerformTask(roleid, Tasks.canEditTest),
            showHealthData: Auth.canPerformTask(roleid, Tasks.canViewHealthData),
            externalUsers: new Map(),
            shareTests: new Map(),
            testListLoading: true,
            testListText : '',
            rtaColumnData: new Map(),
            rtaColumns: []
        };  
        this.rowExpanded = this.rowExpanded.bind(this);
        this.handleActivation = this.handleActivation.bind(this);

    }

    async componentDidMount() {
        Utils.resetScroll();
        // let sportArr = this.getValuesSepByComma(this.getInputValue('sport', ''));
        // if (sportArr.length === 0 || sportArr[0] === '' ) { 
        //     sportArr = [];
        // }
        let user: any = await this.getUser(this.props.match.params.userid);
        let shares: any = await this.getUserShares(this.props.match.params.userid);
        // this.setState({user, shares});
        staticProperties.set(STATICKEYS.selectedKey, VIEWSTATE.USER);
        staticProperties.set(STATICKEYS.selectedRoster, '');
        this.setState({
            sportsArr: this.getCommaStringWithSpace(this.getInputValue('sport', '')),
            levelVal : this.getInputValue('level', ''),
            gender: this.getInputValue('gender', ''),
            user: user,
            shares,
            loading: false,
            emptyText: user !== undefined && user.length === 0 ? 'No data' : ''
        });
    }

    render() { 
        if ( this.state.loading ) {
            return (
                <div>
                    Loading...
                </div>
            );
        }
        let userName = (this.state.user.firstname + ' ') + 
                     this.state.user.lastname;
        return (
            <div className="ViewUser">
            <Card className="cardFont">
            <Breadcrumb>
                <Breadcrumb.Item ><a href="/dashboard">{'Home'}</a></Breadcrumb.Item>
                <Breadcrumb.Item ><a href={'/user'}> {strings.lsUsersTxt} </a>
                </Breadcrumb.Item>
                <Breadcrumb.Item >{this.state.user.firstname + ' ' + 
                                    this.state.user.lastname}</Breadcrumb.Item>
            </Breadcrumb>
            <br/>
            <Row>
            <Col xs={18} sm={12} md={2} lg={2} xl={2}>
                {/* <Icon type="user" style={{ fontSize: 42}} /> */}
                {/* <Avatar  size="large" src={userIcon}/> */}
                <img src={userIcon} />
                
            </Col>
            <Col xs={18} sm={12} md={8} lg={8} xl={8}>
                <h2>{userName} </h2>
            </Col>
            <Col xs={18} sm={12} md={14} lg={14} xl={14}>
            <div className="label">
                {/* <Button 
                    className="backBtn" 
                    onClick={e => {
                            history.back();
                    }}
                >
                    Back
                </Button> */}
                </div>
            </Col>
            </Row>
            <Row>
                <Col xs={18} sm={18} md={18} lg={18} xl={18}>
                    <Row className="viewRow">
                        <Col xs={12} sm={12} md={12} lg={12} xl={12} className="clipped leftSpacing">
                            <span className="infoLabels">  {strings.lsUsrNameTxt}: </span> 
                            <span 
                                className="viewProfileVals" 
                            > {this.state.user.username} 
                            </span>
                        </Col>
                        <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                        <div>
                            <span className="infoLabels">  {strings.lsEmailTxt}: </span> 
                            <span className="viewProfileVals">  {this.state.user.email} </span>
                        </div>
                        </Col>
                    </Row>

                    <Row className="viewRow">
                        <Col xs={12} sm={12} md={12} lg={12} xl={12} className="leftSpacing">
                            <span 
                                className="infoLabels"
                            > {strings.lsRoleTxt}: 
                            </span> 
                            <span 
                                className="viewProfileVals"
                            >  
                                {Utils.getRoleValue(this.state.user.roleid)}
                            </span>
                        </Col>
                        <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                            <div>
                                <span className="infoLabels">  {strings.lsMobilePhTxt}: </span> 
                                <span className="viewProfileVals">  {this.state.user.phone} </span>
                            </div>
                        </Col>
                    </Row>
                    <Row className="viewRow">
                        <Col xs={12} sm={12} md={12} lg={12} xl={12} className="leftSpacing">
                            <span 
                                className="infoLabels"
                            > {strings.lsDeleteTestTxt}: 
                            </span> 
                            <span 
                                className="viewProfileVals"
                            >  
                                {this.state.user.candeletetest === 1 ? strings.lsAllowedTxt : strings.lsNotAllowedTxt}
                            </span>
                        </Col>
                    </Row>                    
                </Col>
            </Row>
        </Card>
        <Card title={strings.lsOrgTxt + 's'} style={{ margin: '24px 16px' }}>
        {
            this.state.user.organizations.map((org, i) => {
                return (
                    <Tag 
                        key={i}
                        style={{marginBottom: 5}}
                    > {org.name}
                    </Tag>
                );
            })
        }
        </Card>
            <div >
                <Card className="cardFont" title={strings.lsShareHistoryTxt} style={{ margin: '24px 16px' }}>
                    {/* <Button 
                        style={{marginLeft: 10, marginBottom: 20 }}
                        onClick={() => this.printList()}
                    >{strings.lsPrintTxt}
                    </Button>   */}
                    {/* <iframe 
                        style={{height: 0, width: 0, border: 'none'}} 
                        ref={el => this.iframe = el} 
                    />   */}

                    {/* <Button 
                            style={{marginLeft: 10, marginBottom: 20 }}
                            onClick={() => this.exportFile()}
                    >{strings.lsDownloadTxt}
                    </Button> */}
                    {/* <Modal
                        title={strings.lsExportUserTxt}
                        visible={this.state.exportModalVisisble}
                        onOk={() => this.setState({exportModalVisisble: false})}
                        okText={strings.lsOkTxt}
                        width={350}
                        bodyStyle={{padding: 0 }}
                        maskClosable={false}
                        closable={false}
                        footer={[
                            <Button 
                                    key="Ok" 
                                    type="primary"  
                                    onClick={() => this.setState({exportModalVisisble: false})}
                            >
                            {strings.lsOkTxt}
                            </Button>,
                        ]}
                    >
                        <Row style={{padding: '19px'}}>
                        {strings.lsTestExportSuccessTxt}
                        </Row>
                    </Modal> */}
                    <ShareList 
                        shares={this.state.shares}
                        notifyShowUsersClick={this.rowExpanded}
                        externalUsers={this.state.externalUsers}
                        notifyActiveClick={this.handleActivation}                       
                        testListLoading={this.state.testListLoading}
                        testListText={this.state.testListText}      
                        shareTests={this.state.shareTests}    
                        rtaColumnData={this.state.rtaColumnData}
                        rtaColumns={this.state.rtaColumns}     
                    />
                </Card>
            </div>
            </div>
        );
    }

    /**
     * Returns value of the property
     * @param property attribute name to extract value from props.org
     * @param defaultVal default value, if attribute not found
     */
    private getInputValue(property: string, defaultVal: string): string {
        let metaInfoMap = this.metaInfoMap;
        let defaultValue: string = '';
        let playerinfo = this.state.user !== '' &&  (this.state.user !== undefined && 
            this.state.user.playerinfo !== undefined)
                    ? this.state.user.playerinfo.filter((e: any) => 
                                e.playerinfoname === property) : '';
        if (playerinfo.length === 0) {
            // defaultValue = this.getDisbledColumnVal(property, this.metaInfoMap);
            if (metaInfoMap !== '' && metaInfoMap !== undefined && metaInfoMap.length > 0) {
                let metaInfo: any = metaInfoMap.filter( (x: any) => 
                    x.metainfoname === property
                );
                if (metaInfo.length > 0) {
                    defaultValue = metaInfo[0].metainfovalue;
                }
            }
        }
        return playerinfo.length !== 0 ? playerinfo[0].playerinfovalue : defaultValue;
    }

    /**
     * Returns array of values obtained by splitting on ','
     * @param commaSepList String containing comma seperated list
     */
    private getCommaStringWithSpace(commaSepList: string) {
        let values: any = commaSepList !== null ? commaSepList.split(',') : [];
        let commaSepString: string = '';
        if (values.length > 0) {
            for (let i = 0; i < values.length; i++) {
                if (i === values.length - 1) {
                    commaSepString += values[i]; 
                } else {
                    commaSepString += values[i] + ', '; 
                }
            }
            return commaSepString;
        } else {
            return commaSepList;
        }
    }

    // private printList() {
    //     console.log('orgsFromPrint', this.state.user.tests);
    //     let buildData: any;
    //     buildData = this.buildTestData(this.state.user.tests);
    //     if (buildData.length > 0) {
    //         Print.printContents(buildData, 'Tests', this.iframe);
    //     }
    // }

    // private exportFile() {
    //     console.log('orgsFromPrint', this.state.user.tests);
    //     let buildData: any;
    //     buildData = this.buildTestData(this.state.user.tests);
    //     if (buildData.length > 0) {
    //         Export.exportCSVFile(buildData, 'tests');
    //         this.setState({exportModalVisisble: true});
    //     }
    // }

    private rowExpanded(shareid: any) {
        this.getTests(shareid);
        this.getExternalUsers(shareid);
    }

    private async getUser(userid: any) {
        let ser = new service(); 
        let user = await ser.getUser(userid);
        console.log('getUser', user);
        return user;
    }

    private async getUserShares(userid: any) {
        let ser = new service(); 
        let shares = await ser.getUserShares(userid);
        console.log('getUser', shares);
        return shares;
    }

    private async getExternalUsers(shareid: any) {
        let ser = new service();
        let externalUsers: any = await ser.getExternalUsers(shareid);
        console.log('getExternalUsers', externalUsers);
        let userMap = this.state.externalUsers;
        userMap.set(shareid, externalUsers);
        this.setState({
            externalUsers: userMap,
            // testListLoading: false,
            // testListText: tests.length === 0 ? 'No Data' : ''
        });
    }

    private async handleActivation(active: number, shareId: string, shareUserId: string, record: any) {
        console.log('record', record);
        let userObj = {
            email: record.email,
            firstname: record.firstname,
            lastname: record.lastname
        };
        let ser = new service();
        let resp = await ser.updateExternalUser(shareUserId, shareId, active, userObj);
        if (resp.status === 0) {
            let msgTerm: string = active === 0 ? strings.lsDeActivatedTxt : strings.lsActivatedTxt;
            message.success(strings.formatString(strings.lsShareSuccessTxt, msgTerm), MSGDISPLAYTIME);  
            this.getExternalUsers(shareId); 
        } else {
            message.success(strings.lsAPIErrorTxt);
        }
        
    }

    /**
     * Gets the tests for a share from the server
     * @param shareid Share id of share for which the tests are to be fetched
     */
    private async getTests(shareid: any) {
        console.log('external shareid', shareid);
        let ser = new service();
        let shareTests: any = await ser.getSharetests(shareid);
        console.log('getsharetest', shareTests);
        let testMap = this.state.shareTests;
        testMap.set(shareid, shareTests);
        this.setState({
            shareTests: testMap,
            testListLoading: false,
            testListText: shareTests.length === 0 ? 'No Data' : '',
        });
        let rtaDataTestMap = this.state.rtaColumnData;
        if (!this.state.rtaColumnData.has(shareid)) {
            let rtaData = this.getRTAData(shareTests, shareid );
            let columnData = this.buildRTAData(rtaData);
            rtaDataTestMap.set(shareid, columnData);
        }

        let columns = this.buildRTAColumns();
        this.setState({
            rtaColumnData: rtaDataTestMap,
            rtaColumns: columns
        });
    }

    private getRTAData(sharetests: any, shareid: any) {
        if (sharetests.length > 0) {
            let total = sharetests.length;
            console.log('getRTADatasharetest', sharetests[0]);
            console.log(sharetests[0].testtimestamp.toString() + '-' + 
                            sharetests[total - 1].testtimestamp.toString());

            return {
                name : sharetests[0].athlete.firstname + ' ' +
                    sharetests[0].athlete.lastname ,
                daterange: Utils.getDate(sharetests[0].testtimestamp) + '—' + 
                                Utils.getDate(sharetests[total - 1].testtimestamp),
                testCount: total,
                shareid: shareid
            };
        } else {
            return {
                
            };
        }
    }

    private buildRTAData(element: any) {
        let columnData: Array<any> = [];
        let data = {
            name: element.name,
            date_range: element.daterange,
            testCount: element.testCount,
            shareid: element.shareid
        };
        columnData.push(data);
        return columnData;
    }

    private buildRTAColumns() {
        let columns = [
          {
            title: strings_dashboard.lsProfileNameTxt,
            dataIndex: 'name',
            className: 'rows'
          },
          {
            title: strings_dashboard.lsDateRangeTxt,
            dataIndex: 'date_range',
            className: 'rows'
          },
          {
            title: strings_dashboard.lsTestTxt,
            dataIndex: 'testCount',
            className: 'rows'
          },
        ];
        return columns;
    }
}


// WEBPACK FOOTER //
// ./src/components/user/ViewUser.tsx